import * as React from 'react'

import {Surface, SurfaceMode} from "@jsplumbtoolkit/browser-ui"
import {BrowserUIReact, } from "@jsplumbtoolkit/browser-ui-react"


import "./CanvasControls.scss"
import { FiZoomIn, FiZoomOut } from 'react-icons/fi'
import {MdZoomOutMap} from "react-icons/md"
import { AiOutlineRedo, AiOutlineUndo } from 'react-icons/ai'
export class CanvasControls extends React.Component<any, any> {

    surface?:Surface
    toolkit?:BrowserUIReact
    _container?:HTMLElement

    constructor(props:any) {
        super(props)
    }


    initialize(surface:Surface) {
        this.surface = surface
        this.toolkit = surface.toolkitInstance
        // this.undoManager = NewUndoRedoManager({
        //     surface:this.surface,
        //     compound:true,
        //     onChange:(mgr:any, undoCount:number, redoCount:number) => {
        //         this._container.setAttribute("can-undo", undoCount > 0 ? "true" : "false")
        //         this._container.setAttribute("can-redo", redoCount > 0 ? "true" : "false")
        //     }
        // });

    }

    reset() {
        this.toolkit?.clearSelection()
        this.surface?.zoomToFit()
    }

    panMode() {
        this.surface?.setMode(SurfaceMode.PAN)
    }

    selectMode() {        
        this.surface?.setMode(SurfaceMode.SELECT)
    }

    undo() {
        this.toolkit?.undo()
    }

    redo() {
        this.toolkit?.redo()
    }
    zoomIn() {
        this.surface?.nudgeZoom(0.2)
    }
    zoomOut() {
        this.surface?.nudgeZoom(-0.2)
    }

    clear() {
        // eslint-disable-next-line no-restricted-globals
        if (this.toolkit?.getNodeCount() === 0 || confirm("Clear flowchart?")) {
            this.toolkit?.clear()
        }
    }



    render() {
        return <div className="CanvasControls" ref={(c) => (this._container as any) = c}>
                <div className="zoomButtons">
                    <div className="zoomButton in"onClick={this.zoomIn.bind(this)}><FiZoomIn/></div>
                    <div className="zoomButton out" onClick={this.zoomOut.bind(this)}><FiZoomOut/></div>
                    <div className="zoomButton fit"  onClick={this.reset.bind(this)}><MdZoomOutMap/></div>
                </div>
                <div className='undoRedo'> 
                <div className="undoRedoButton" onClick={this.undo.bind(this)}><AiOutlineUndo/> UNDO</div>
                <div className="undoRedoButton" onClick={this.redo.bind(this)}><AiOutlineRedo/> REDO</div>


                </div>
        </div>
    }
}
